import { CSSProperties, useMemo, useRef } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useViewportDevice } from '@zep/react';
import { Button } from '@zep/ui';
import { cn } from '@zep/utils';
import { usePrice } from '../../../../../services';
import { joinUtmQueryParams, urlRegex } from '../../../../../utils';
import { ExportIcon } from '../../../../icons';
import { Accordion } from './Accordion';
import S from './PricingFAQ.module.scss';
const ConvertLinkToATag = ({
  linkText
}: {
  linkText: string;
}) => {
  const replacedText = linkText.replace(urlRegex, `<a href="$&" target="_blank" style="color: #3398e8;">$&</a>`);
  return <div dangerouslySetInnerHTML={{
    __html: replacedText
  }} data-sentry-component="ConvertLinkToATag" data-sentry-source-file="PricingFAQ.tsx" />;
};
export const PricingFAQ = () => {
  const {
    data
  } = usePrice({
    suspense: true
  });
  const faqListRef = useRef<HTMLDivElement>(null);
  const router = useRouter();
  const {
    t
  } = useTranslation(['subscription'], {
    useSuspense: true
  });
  const {
    isPortableDevice
  } = useViewportDevice();
  const userType = 'normal';
  const filteredFAQList = useMemo(() => data?.PricingFAQ?.list.filter(({
    type
  }) => !type || type === userType), [data?.PricingFAQ, userType]);
  const hideOtherAccordion = (id: number) => {
    if (!faqListRef.current) return;
    const items = Array.from(faqListRef.current.querySelectorAll('[data-id]')).filter(el => el.getAttribute('data-id') !== `${id}`);
    items.forEach(el => (el as HTMLElement).click());
  };
  return <section className={S.section} data-sentry-component="PricingFAQ" data-sentry-source-file="PricingFAQ.tsx">
      <div className={S.inner}>
        <h2 className={S.title}>{t('subscription:pricing.faq.title')}</h2>

        <div ref={faqListRef} className={S.faq}>
          {filteredFAQList?.map((faq, index) => <Accordion id={index} title={faq.ask} key={index} onClick={() => hideOtherAccordion(index)} data-motion-item style={{
          '--motion-delay': `${0.1 * index}s`
        } as CSSProperties} open={index === 0}>
              <ConvertLinkToATag linkText={faq.answer} />
            </Accordion>)}
        </div>

        <div className={S.button_area}>
          <Button as="a" href={joinUtmQueryParams(t('subscription:pricing.faq.buttonLink'), router)} target="_blank" variant="secondary" className={cn('rounded-full', isPortableDevice ? 'min-w-[200px]' : 'min-w-[250px]')} size={isPortableDevice ? 'sm' : 'lg'} leftSlot={<ExportIcon width={18} height={18} />} onClick={() => logger.track('home_pricing_faq')} data-sentry-element="Button" data-sentry-source-file="PricingFAQ.tsx">
            {t('subscription:pricing.faq.buttonText')}
          </Button>
        </div>
      </div>
    </section>;
};